/* eslint-disable consistent-return */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IS_MOBILE, IS_TAB } from '../../../utils/common';

const Carousel = ({ itemWidth, children, noOfItems }) => {
  const containerRef = useRef();
  const carouselRef = useRef();
  const scrollRef = useRef();

  const [containerWidth, setContainerWidth] = useState(0);
  const [hideNextButton, setHideNextButton] = useState(false);
  const [hidePrevButton, setHidePrevButton] = useState(true);
  const BUTTON_MARGIN = 60;
  const ITEM_MARGIN = 10;

  const calculatedCardWidth = itemWidth + ITEM_MARGIN;

  useEffect(() => {
    const { width: contWidth } = containerRef.current.getBoundingClientRect();
    setContainerWidth(contWidth + BUTTON_MARGIN);
    setHideNextButton(false);
    setHidePrevButton(true);
  }, [children, containerRef.current]);

  useEffect(() => {
    if (IS_MOBILE && noOfItems <= 2) {
      setHideNextButton(true);
      setHidePrevButton(true);
    }
  }, [children, noOfItems]);

  const handleNext = () => {
    const element = scrollRef.current;
    setHidePrevButton(false);
    if (element.scrollLeft === containerWidth) return setHideNextButton(true);
    if (element.offsetWidth + element.scrollLeft >= element.scrollWidth) {
      setHidePrevButton(false);
      setHideNextButton(true);
    }
    element.scrollLeft += calculatedCardWidth;
  };

  const handlePrevious = () => {
    const element = scrollRef.current;
    setHideNextButton(false);
    if (element.scrollLeft === 0) {
      setHideNextButton(false);
      return setHidePrevButton(true);
    }
    element.scrollLeft -= calculatedCardWidth;
  };

  const handleScroll = () => {
    const element = scrollRef.current;
    setHideNextButton(false);
    setHidePrevButton(false);

    if (element.offsetWidth + element.scrollLeft >= element.scrollWidth) {
      setHidePrevButton(false);
      return setHideNextButton(true);
    }
    if (element.scrollLeft === 0) {
      setHideNextButton(false);
      return setHidePrevButton(true);
    }
  };

  return (
    <div className="carousel" ref={carouselRef}>
      {!hideNextButton && (
        <div
          role="presentation"
          className="carousel_btn carousel_nextbtn"
          onClick={handleNext}
        >
          <svg
            width="15"
            height="15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4.814 15l7.5-7.5-7.5-7.5-2.128 2.128L8.06 7.5l-5.373 5.372L4.814 15z" />
          </svg>
        </div>
      )}
      {!hidePrevButton && (
        <div
          role="presentation"
          className="carousel_btn carousel_prevbtn"
          onClick={handlePrevious}
        >
          <svg
            width="15"
            height="15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10.186 0l-7.5 7.5 7.5 7.5 2.128-2.128L6.94 7.5l5.373-5.372L10.186 0z" />
          </svg>
        </div>
      )}
      <div className="carousel_wrap" ref={scrollRef} onScroll={handleScroll}>
        <div className="carousel_container" ref={containerRef}>
          {children}
        </div>
      </div>
    </div>
  );
};

Carousel.propTypes = {
  noOfItems: PropTypes.number,
  children: PropTypes.array,
  itemWidth: PropTypes.number,
  tab: PropTypes.object,
  onPreviewButtonClick: PropTypes.func
};

export default Carousel;
